
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function PermisosTable() {
  const [permisos, setPermisos] = useState([]);
  const [filteredPermisos, setFilteredPermisos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchObservaciones, setSearchObservaciones] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [selectedTercero, setSelectedTercero] = useState(null);
  const [searchSepulturaId, setSearchSepulturaId] = useState('');
  const [pageBlock, setPageBlock] = useState(0); // Cada bloque tiene 10 páginas
  const pagesPerBlock = 10;
  

  useEffect(() => {
    fetchPermisos();
    fetchTerceros();
  }, []);

  /*
  useEffect(() => {
    filterPermisos();
  }, [searchObservaciones, searchTercero,startDate,endDate, permisos]);
*/


useEffect(() => {
  filterPermisos();
}, [searchObservaciones, searchTercero, searchSepulturaId, startDate, endDate, permisos]);





  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchPermisos = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/permisos');
      setPermisos(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los permisos. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterPermisos = () => {
    let filtered = permisos.filter(permiso =>
      (permiso.observaciones?.toLowerCase().includes(searchObservaciones.toLowerCase()) || searchObservaciones === '') &&
      (permiso.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
        terceros.some(tercero =>
          tercero.documento === permiso.terceroId &&
          tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
        ) || searchTercero === '') &&
      (!startDate || new Date(permiso.fecha) >= new Date(startDate)) &&
      (!endDate || new Date(permiso.fecha) <= new Date(endDate)) &&
      (permiso.sepulturaId.toString().includes(searchSepulturaId) || searchSepulturaId === '')
     //permiso.sepulturaId.toString().includes(searchSepulturaId) // <-- esta línea nueva
    );
    setFilteredPermisos(filtered);
  };
  


  /*
  const filterPermisos = () => {
    let filtered = permisos.filter(permiso =>
      (permiso.observaciones?.toLowerCase().includes(searchObservaciones.toLowerCase()) || searchObservaciones === '') &&
      (permiso.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
        terceros.some(tercero =>
          tercero.documento === permiso.terceroId &&
          tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
        ) || searchTercero === '')  &&
      (!startDate || new Date(permiso.fecha) >= new Date(startDate)) &&
      (!endDate || new Date(permiso.fecha) <= new Date(endDate))
    );
    setFilteredPermisos(filtered);
  };
*/
  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este permiso?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/permisos/${id}`);
        fetchPermisos();
      } catch (err) {
        setError('Error al eliminar el permiso. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handlePrint = async (terceroId) => {
    if (!terceroId) return;
    try {
      const response = await axios.get(`/sepulturasc/${terceroId}/pdfpermisoc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Permiso_${terceroId}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF del permiso.');
    }
  };


/*  
  const handlePrint = async (sepulturaId) => {
    if (!sepulturaId) return;
    try {
      const response = await axios.get(`/sepulturasc/${sepulturaId}/pdfpermisoc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Permiso_${sepulturaId}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF del permiso.');
    }
  };
*/


const paginate = (pageNumber) => {
  setCurrentPage(pageNumber);
};

const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = filteredPermisos.slice(indexOfFirstItem, indexOfLastItem);

const totalPages = Math.ceil(filteredPermisos.length / itemsPerPage);
//const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

const startPage = pageBlock * pagesPerBlock;
const endPage = Math.min(startPage + pagesPerBlock, totalPages);
const pageNumbers = Array.from({ length: endPage - startPage }, (_, i) => startPage + i + 1);


/*
  const totalPages = Math.ceil(filteredPermisos.length / itemsPerPage);
  const currentItems = filteredPermisos.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
*/


  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Permisos</h1>
      <div className="flex justify-between mb-4">

    <div className="relative space-y-2 w-full">
    <input
      type="text"
      placeholder="Buscar por Tercero documento..."
      value={searchTercero}
      onChange={(e) => setSearchTercero(e.target.value)}
      className="border p-2 w-full text-sm"
    />
    {filteredTerceros.length > 0 && searchTercero && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredTerceros.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => {
              setSelectedTercero(tercero); // Guardar el tercero seleccionado
              setSearchTercero(tercero.documento); // Opcional: Llenar el input con el documento
            }}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}

    {selectedTercero && (
      <div className="border p-2 mt-2 bg-gray-100">
        <p><strong>Nombre:</strong> {selectedTercero.nombre}</p>
        <p><strong>Documento:</strong> {selectedTercero.documento}</p>
      </div>
    )}
  </div>


        {/* anterior
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por Observaciones"
            className="border p-2 rounded w-1/4"
            value={searchObservaciones}
            onChange={(e) => setSearchObservaciones(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/4"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/4"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        */}

        <Link to="/home/permisos/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Permiso
        </Link>
      </div>

      <div className="flex space-x-4 w-full">
 
         <input
            type="text"
            placeholder="Buscar por Sepultura ID..."
            value={searchSepulturaId}
            onChange={(e) => setSearchSepulturaId(e.target.value)}
            className="border p-2 rounded w-1/5"
          />

          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

      
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Funeraria</th>
              <th className="px-6 py-3">Hora Defunción</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">ID Línea</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((permiso) => (
              <tr key={permiso.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{permiso.id}</td>
                <td className="px-6 py-4">{permiso.fecha}</td>
                <td className="px-6 py-4">{permiso.terceroId}</td>
                <td className="px-6 py-4">{permiso.funeraria}</td>
                <td className="px-6 py-4">{permiso.horaDefuncion}</td>
                <td className="px-6 py-4">{permiso.observaciones}</td>
                <td className="px-6 py-4">{permiso.sepulturaId}</td>
                <td className="px-6 py-4">{permiso.idLinea}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/permisos/${permiso.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/permisos/edit/${permiso.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(permiso.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                  <button onClick={() => handlePrint(permiso.terceroId)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
               
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="flex justify-center items-center mt-4 space-x-2">
  {pageBlock > 0 && (
    <button
      onClick={() => setPageBlock(pageBlock - 1)}
      className="px-4 py-2 rounded bg-gray-400 text-white"
    >
      ← Anteriores
    </button>
  )}
  {pageNumbers.map((number) => (
    <button
      key={number}
      onClick={() => setCurrentPage(number)}
      className={`px-4 py-2 rounded ${currentPage === number ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
    >
      {number}
    </button>
  ))}
  {(pageBlock + 1) * pagesPerBlock < totalPages && (
    <button
      onClick={() => setPageBlock(pageBlock + 1)}
      className="px-4 py-2 rounded bg-gray-400 text-white"
    >
      Siguientes →
    </button>
  )}
</div>







        {/*
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button 
              key={number + 1}
              onClick={() => setCurrentPage(number + 1)}
              className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
            >
              {number + 1}
            </button>
          ))}
        </div> 
        */}
      </div>
    </div>
  );
}




/*
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function PermisosTable() {
  const [permisos, setPermisos] = useState([]);
  const [filteredPermisos, setFilteredPermisos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchObservaciones, setSearchObservaciones] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [selectedTercero, setSelectedTercero] = useState(null);
  const [searchSepulturaId, setSearchSepulturaId] = useState('');


  useEffect(() => {
    fetchPermisos();
    fetchTerceros();
  }, []);

 


useEffect(() => {
  filterPermisos();
}, [searchObservaciones, searchTercero, searchSepulturaId, startDate, endDate, permisos]);





  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchPermisos = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/permisos');
      setPermisos(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los permisos. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterPermisos = () => {
    let filtered = permisos.filter(permiso =>
      (permiso.observaciones?.toLowerCase().includes(searchObservaciones.toLowerCase()) || searchObservaciones === '') &&
      (permiso.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
        terceros.some(tercero =>
          tercero.documento === permiso.terceroId &&
          tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
        ) || searchTercero === '') &&
      (!startDate || new Date(permiso.fecha) >= new Date(startDate)) &&
      (!endDate || new Date(permiso.fecha) <= new Date(endDate)) &&
      (permiso.sepulturaId.toString().includes(searchSepulturaId) || searchSepulturaId === '')
     //permiso.sepulturaId.toString().includes(searchSepulturaId) // <-- esta línea nueva
    );
    setFilteredPermisos(filtered);
  };
  


  
  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este permiso?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/permisos/${id}`);
        fetchPermisos();
      } catch (err) {
        setError('Error al eliminar el permiso. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handlePrint = async (terceroId) => {
    if (!terceroId) return;
    try {
      const response = await axios.get(`/sepulturasc/${terceroId}/pdfpermisoc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Permiso_${terceroId}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF del permiso.');
    }
  };



  const totalPages = Math.ceil(filteredPermisos.length / itemsPerPage);
  const currentItems = filteredPermisos.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Permisos</h1>
      <div className="flex justify-between mb-4">

    <div className="relative space-y-2 w-full">
    <input
      type="text"
      placeholder="Buscar por Tercero documento..."
      value={searchTercero}
      onChange={(e) => setSearchTercero(e.target.value)}
      className="border p-2 w-full text-sm"
    />
    {filteredTerceros.length > 0 && searchTercero && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredTerceros.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => {
              setSelectedTercero(tercero); // Guardar el tercero seleccionado
              setSearchTercero(tercero.documento); // Opcional: Llenar el input con el documento
            }}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}

    {selectedTercero && (
      <div className="border p-2 mt-2 bg-gray-100">
        <p><strong>Nombre:</strong> {selectedTercero.nombre}</p>
        <p><strong>Documento:</strong> {selectedTercero.documento}</p>
      </div>
    )}
  </div>


        <Link to="/home/permisos/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Permiso
        </Link>
      </div>

      <div className="flex space-x-4 w-full">
 
         <input
            type="text"
            placeholder="Buscar por Sepultura ID..."
            value={searchSepulturaId}
            onChange={(e) => setSearchSepulturaId(e.target.value)}
            className="border p-2 rounded w-1/5"
          />

          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

      
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Funeraria</th>
              <th className="px-6 py-3">Hora Defunción</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">ID Línea</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((permiso) => (
              <tr key={permiso.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{permiso.id}</td>
                <td className="px-6 py-4">{permiso.fecha}</td>
                <td className="px-6 py-4">{permiso.terceroId}</td>
                <td className="px-6 py-4">{permiso.funeraria}</td>
                <td className="px-6 py-4">{permiso.horaDefuncion}</td>
                <td className="px-6 py-4">{permiso.observaciones}</td>
                <td className="px-6 py-4">{permiso.sepulturaId}</td>
                <td className="px-6 py-4">{permiso.idLinea}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/permisos/${permiso.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/permisos/edit/${permiso.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(permiso.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                  <button onClick={() => handlePrint(permiso.terceroId)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
               
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button 
              key={number + 1}
              onClick={() => setCurrentPage(number + 1)}
              className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
            >
              {number + 1}
            </button>
          ))}
        </div> 
      </div>
    </div>
  );
}
*/

/*
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function PermisosTable() {
  const [permisos, setPermisos] = useState([]);
  const [filteredPermisos, setFilteredPermisos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchObservaciones, setSearchObservaciones] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [selectedTercero, setSelectedTercero] = useState(null);

  useEffect(() => {
    fetchPermisos();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterPermisos();
  }, [searchObservaciones, searchTercero,startDate,endDate, permisos]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchPermisos = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/permisos');
      setPermisos(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los permisos. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterPermisos = () => {
    let filtered = permisos.filter(permiso =>
      (permiso.observaciones?.toLowerCase().includes(searchObservaciones.toLowerCase()) || searchObservaciones === '') &&
      (permiso.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
        terceros.some(tercero =>
          tercero.documento === permiso.terceroId &&
          tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
        ) || searchTercero === '')  &&
      (!startDate || new Date(permiso.fecha) >= new Date(startDate)) &&
      (!endDate || new Date(permiso.fecha) <= new Date(endDate))
    );
    setFilteredPermisos(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este permiso?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/permisos/${id}`);
        fetchPermisos();
      } catch (err) {
        setError('Error al eliminar el permiso. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handlePrint = async (terceroId) => {
    if (!terceroId) return;
    try {
      const response = await axios.get(`/sepulturasc/${terceroId}/pdfpermisoc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Permiso_${terceroId}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF del permiso.');
    }
  };


  const totalPages = Math.ceil(filteredPermisos.length / itemsPerPage);
  const currentItems = filteredPermisos.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Permisos</h1>
      <div className="flex justify-between mb-4">

    <div className="relative space-y-2 w-full">
    <input
      type="text"
      placeholder="Buscar por Tercero documento..."
      value={searchTercero}
      onChange={(e) => setSearchTercero(e.target.value)}
      className="border p-2 w-full text-sm"
    />
    {filteredTerceros.length > 0 && searchTercero && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredTerceros.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => {
              setSelectedTercero(tercero); // Guardar el tercero seleccionado
              setSearchTercero(tercero.documento); // Opcional: Llenar el input con el documento
            }}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}

    {selectedTercero && (
      <div className="border p-2 mt-2 bg-gray-100">
        <p><strong>Nombre:</strong> {selectedTercero.nombre}</p>
        <p><strong>Documento:</strong> {selectedTercero.documento}</p>
      </div>
    )}
  </div>


        
        <Link to="/home/permisos/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Permiso
        </Link>
      </div>

      <div className="flex space-x-4 w-full">
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

      
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Funeraria</th>
              <th className="px-6 py-3">Hora Defunción</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">ID Línea</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((permiso) => (
              <tr key={permiso.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{permiso.id}</td>
                <td className="px-6 py-4">{permiso.fecha}</td>
                <td className="px-6 py-4">{permiso.terceroId}</td>
                <td className="px-6 py-4">{permiso.funeraria}</td>
                <td className="px-6 py-4">{permiso.horaDefuncion}</td>
                <td className="px-6 py-4">{permiso.observaciones}</td>
                <td className="px-6 py-4">{permiso.sepulturaId}</td>
                <td className="px-6 py-4">{permiso.idLinea}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/permisos/${permiso.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/permisos/edit/${permiso.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(permiso.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                  <button onClick={() => handlePrint(permiso.terceroId)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
               
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button 
              key={number + 1}
              onClick={() => setCurrentPage(number + 1)}
              className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
            >
              {number + 1}
            </button>
          ))}
        </div> 
      </div>
    </div>
  );
}
*/

/*
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function PermisosTable() {
  const [permisos, setPermisos] = useState([]);
  const [filteredPermisos, setFilteredPermisos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchObservaciones, setSearchObservaciones] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchPermisos();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterPermisos();
  }, [searchObservaciones, searchTercero,startDate,endDate, permisos]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchPermisos = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/permisos');
      setPermisos(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los permisos. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterPermisos = () => {
    let filtered = permisos.filter(permiso =>
      (permiso.observaciones?.toLowerCase().includes(searchObservaciones.toLowerCase()) || searchObservaciones === '') &&
      (permiso.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
        terceros.some(tercero =>
          tercero.documento === permiso.terceroId &&
          tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
        ) || searchTercero === '')  &&
      (!startDate || new Date(permiso.fecha) >= new Date(startDate)) &&
      (!endDate || new Date(permiso.fecha) <= new Date(endDate))
    );
    setFilteredPermisos(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este permiso?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/permisos/${id}`);
        fetchPermisos();
      } catch (err) {
        setError('Error al eliminar el permiso. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handlePrint = async (terceroId) => {
    if (!terceroId) return;
    try {
      const response = await axios.get(`/sepulturasc/${terceroId}/pdfpermisoc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Permiso_${terceroId}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF del permiso.');
    }
  };


  const totalPages = Math.ceil(filteredPermisos.length / itemsPerPage);
  const currentItems = filteredPermisos.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Permisos</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por Observaciones"
            className="border p-2 rounded w-1/4"
            value={searchObservaciones}
            onChange={(e) => setSearchObservaciones(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/4"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/4"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        <Link to="/home/permisos/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Permiso
        </Link>
      </div>

      <div className="flex space-x-4 w-full">
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

      
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Funeraria</th>
              <th className="px-6 py-3">Hora Defunción</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">ID Línea</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((permiso) => (
              <tr key={permiso.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{permiso.id}</td>
                <td className="px-6 py-4">{permiso.fecha}</td>
                <td className="px-6 py-4">{permiso.terceroId}</td>
                <td className="px-6 py-4">{permiso.funeraria}</td>
                <td className="px-6 py-4">{permiso.horaDefuncion}</td>
                <td className="px-6 py-4">{permiso.observaciones}</td>
                <td className="px-6 py-4">{permiso.sepulturaId}</td>
                <td className="px-6 py-4">{permiso.idLinea}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/permisos/${permiso.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/permisos/edit/${permiso.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(permiso.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                  <button onClick={() => handlePrint(permiso.terceroId)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
               
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button 
              key={number + 1}
              onClick={() => setCurrentPage(number + 1)}
              className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
            >
              {number + 1}
            </button>
          ))}
        </div> 
      </div>
    </div>
  );
}
*/

/* correcto
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function PermisosTable() {
  const [permisos, setPermisos] = useState([]);
  const [filteredPermisos, setFilteredPermisos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchObservaciones, setSearchObservaciones] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchPermisos();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterPermisos();
  }, [searchObservaciones, searchTercero,startDate,endDate, permisos]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchPermisos = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/permisos');
      setPermisos(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los permisos. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterPermisos = () => {
    let filtered = permisos.filter(permiso =>
      (permiso.observaciones?.toLowerCase().includes(searchObservaciones.toLowerCase()) || searchObservaciones === '') &&
      (permiso.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
        terceros.some(tercero =>
          tercero.documento === permiso.terceroId &&
          tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
        ) || searchTercero === '')  &&
      (!startDate || new Date(permiso.fecha) >= new Date(startDate)) &&
      (!endDate || new Date(permiso.fecha) <= new Date(endDate))
    );
    setFilteredPermisos(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este permiso?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/permisos/${id}`);
        fetchPermisos();
      } catch (err) {
        setError('Error al eliminar el permiso. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };


  const totalPages = Math.ceil(filteredPermisos.length / itemsPerPage);
  const currentItems = filteredPermisos.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Permisos</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por Observaciones"
            className="border p-2 rounded w-1/4"
            value={searchObservaciones}
            onChange={(e) => setSearchObservaciones(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/4"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/4"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        <Link to="/home/permisos/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Permiso
        </Link>
      </div>

      <div className="flex space-x-4 w-full">
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

      
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Funeraria</th>
              <th className="px-6 py-3">Hora Defunción</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">ID Línea</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((permiso) => (
              <tr key={permiso.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{permiso.id}</td>
                <td className="px-6 py-4">{permiso.fecha}</td>
                <td className="px-6 py-4">{permiso.terceroId}</td>
                <td className="px-6 py-4">{permiso.funeraria}</td>
                <td className="px-6 py-4">{permiso.horaDefuncion}</td>
                <td className="px-6 py-4">{permiso.observaciones}</td>
                <td className="px-6 py-4">{permiso.sepulturaId}</td>
                <td className="px-6 py-4">{permiso.idLinea}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/permisos/${permiso.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/permisos/edit/${permiso.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(permiso.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button 
              key={number + 1}
              onClick={() => setCurrentPage(number + 1)}
              className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
            >
              {number + 1}
            </button>
          ))}
        </div> 
      </div>
    </div>
  );
}
*/
/*
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function PermisosTable() {
  const [permisos, setPermisos] = useState([]);
  const [filteredPermisos, setFilteredPermisos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchObservaciones, setSearchObservaciones] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchPermisos();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterPermisos();
  }, [searchObservaciones, searchTercero, permisos]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchPermisos = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/permisos');
      setPermisos(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los permisos. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterPermisos = () => {
    let filtered = permisos.filter(permiso =>
      (permiso.observaciones?.toLowerCase().includes(searchObservaciones.toLowerCase()) || searchObservaciones === '') &&
      (permiso.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
        terceros.some(tercero =>
          tercero.documento === permiso.terceroId &&
          tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
        ) || searchTercero === '')
    );
    setFilteredPermisos(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este permiso?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/permisos/${id}`);
        fetchPermisos();
      } catch (err) {
        setError('Error al eliminar el permiso. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };


  const totalPages = Math.ceil(filteredPermisos.length / itemsPerPage);
  const currentItems = filteredPermisos.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Permisos</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por Observaciones"
            className="border p-2 rounded w-1/4"
            value={searchObservaciones}
            onChange={(e) => setSearchObservaciones(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/4"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/4"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        <Link to="/home/permisos/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Permiso
        </Link>
      </div>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Funeraria</th>
              <th className="px-6 py-3">Hora Defunción</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">ID Línea</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((permiso) => (
              <tr key={permiso.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{permiso.id}</td>
                <td className="px-6 py-4">{permiso.fecha}</td>
                <td className="px-6 py-4">{permiso.terceroId}</td>
                <td className="px-6 py-4">{permiso.funeraria}</td>
                <td className="px-6 py-4">{permiso.horaDefuncion}</td>
                <td className="px-6 py-4">{permiso.observaciones}</td>
                <td className="px-6 py-4">{permiso.sepulturaId}</td>
                <td className="px-6 py-4">{permiso.idLinea}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/permisos/${permiso.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/permisos/edit/${permiso.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(permiso.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button 
              key={number + 1}
              onClick={() => setCurrentPage(number + 1)}
              className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
            >
              {number + 1}
            </button>
          ))}
        </div> 
      </div>
    </div>
  );
}
*/
/* CORRECTO CON BUSQUEDA POR TERCEROS
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function PermisosTable() {
  const [permisos, setPermisos] = useState([]);
  const [filteredPermisos, setFilteredPermisos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchPermisos();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterPermisos();
  }, [searchTercero, permisos]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchPermisos = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/permisos');
      setPermisos(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los permisos. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterPermisos = () => {
    let filtered = permisos.filter(permiso =>
      permiso.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
      terceros.some(tercero =>
        tercero.documento === permiso.terceroId &&
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
    setFilteredPermisos(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este permiso?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/permisos/${id}`);
        fetchPermisos();
      } catch (err) {
        setError('Error al eliminar el permiso. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const totalPages = Math.ceil(filteredPermisos.length / itemsPerPage);
  const currentItems = filteredPermisos.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Permisos</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        <Link to="/home/permisos/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Permiso
        </Link>
      </div>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Funeraria</th>
              <th className="px-6 py-3">Hora Defunción</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">ID Línea</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((permiso) => (
              <tr key={permiso.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{permiso.id}</td>
                <td className="px-6 py-4">{permiso.fecha}</td>
                <td className="px-6 py-4">{permiso.terceroId}</td>
                <td className="px-6 py-4">{permiso.funeraria}</td>
                <td className="px-6 py-4">{permiso.horaDefuncion}</td>
                <td className="px-6 py-4">{permiso.observaciones}</td>
                <td className="px-6 py-4">{permiso.sepulturaId}</td>
                <td className="px-6 py-4">{permiso.idLinea}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/permisos/${permiso.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/permisos/edit/${permiso.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(permiso.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button 
              key={number + 1}
              onClick={() => setCurrentPage(number + 1)}
              className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
            >
              {number + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
*/

/* CORRECTO
import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaEye, FaPlus, FaSearch, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function PermisosTable() {
  const [permisos, setPermisos] = useState([]);
  const [filteredPermisos, setFilteredPermisos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState('id');
  const [sortDirection, setSortDirection] = useState('desc');

  useEffect(() => {
    fetchPermisos();
  }, []);

  useEffect(() => {
    filterAndSortPermisos();
  }, [searchTerm, permisos, sortColumn, sortDirection]);

  const fetchPermisos = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/permisos');
      setPermisos(response.data);
      setFilteredPermisos(response.data);
    } catch (err) {
      setError('Error al cargar los permisos. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const filterAndSortPermisos = () => {
    let filtered = permisos.filter(permiso =>
      permiso.terceroId.toString().includes(searchTerm)
    );

    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredPermisos(sorted);
    setCurrentPage(1);
  };

  const handleDeletePermiso = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este permiso?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/permisos/${id}`);
        fetchPermisos();
      } catch (err) {
        setError('Error al eliminar el permiso. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleSort = (column) => {
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortColumn(column);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredPermisos.slice(indexOfFirstItem, indexOfLastItem);
  
  const totalPages = Math.ceil(filteredPermisos.length / itemsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Permisos</h1>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-8">
        <div className="p-4 flex justify-between items-center bg-gray-50">
          <h2 className="text-xl font-semibold">Tabla de Permisos</h2>
          <Link
            to="/home/permisos/add"
            className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center"
          >
            <FaPlus className="mr-2" /> Añadir Permiso
          </Link>
        </div>
        <div className="p-4 flex items-center bg-gray-100">
          <FaSearch className="mr-2" />
          <input
            type="text"
            placeholder="Buscar por Tercero ID"
            className="border p-2 rounded w-64"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-blue-500 text-white">
              <tr>
                {[ 'id', 'terceroId', 'fecha', 'funeraria', 'horaDefuncion', 'observaciones', 'sepulturaId', 'idLinea' ].map((col) => (
                  <th
                    key={col}
                    className="px-6 py-3 cursor-pointer"
                    onClick={() => handleSort(col)}
                  >
                    {col.charAt(0).toUpperCase() + col.slice(1)}{' '}
                    {sortColumn === col &&
                      (sortDirection === 'asc' ? (
                        <FaSortAmountUp />
                      ) : (
                        <FaSortAmountDown />
                      ))}
                  </th>
                ))}
                <th className="px-6 py-3">Acciones</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentItems.map((permiso) => (
                <tr key={permiso.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">{permiso.id}</td>
                  <td className="px-6 py-4">{permiso.terceroId}</td>
                  <td className="px-6 py-4">{permiso.fecha}</td>
                  <td className="px-6 py-4">{permiso.funeraria}</td>
                  <td className="px-6 py-4">{permiso.horaDefuncion}</td>
                  <td className="px-6 py-4">{permiso.observaciones}</td>
                  <td className="px-6 py-4">{permiso.sepulturaId}</td>
                  <td className="px-6 py-4">{permiso.idLinea}</td>
                  <td className="px-6 py-4 flex space-x-2">
                    <Link to={`/home/permisos/${permiso.id}`} className="text-blue-600 hover:text-blue-900">
                      <FaEye />
                    </Link>
                    <Link to={`/home/permisos/edit/${permiso.id}`} className="text-green-600 hover:text-green-900">
                      <FaEdit />
                    </Link>
                    <button onClick={() => handleDeletePermiso(permiso.id)} className="text-red-600 hover:text-red-900">
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-center space-x-2 mt-4">
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => paginate(index + 1)}
              className={`px-4 py-2 border rounded ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
*/

/*
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const PermisoList = () => {
  const [permisos, setPermisos] = useState([]);
  const [search, setSearch] = useState('');
  const [filteredPermisos, setFilteredPermisos] = useState([]);
  const [editPermiso, setEditPermiso] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  const [newPermiso, setNewPermiso] = useState({
    terceroId: '', fecha: '', funeraria: '', horaDefuncion: '',
    observaciones: '', sepulturaId: '', idLinea: ''
  });

  useEffect(() => {
    axios.get('http://localhost:3000/permisos')
      .then(response => {
        setPermisos(response.data);
        setFilteredPermisos(response.data);
      })
      .catch(error => {
        console.error('Error fetching permisos:', error);
      });
  }, []);

  useEffect(() => {
    setFilteredPermisos(
      permisos.filter(permiso =>
        (permiso.terceroId ? permiso.terceroId.toString().toLowerCase() : '').includes(search.toLowerCase())
      )
    );
    setCurrentPage(1);
  }, [search, permisos]);

  const handleEdit = (permiso) => {
    setEditPermiso(permiso);
    setNewPermiso(permiso);
  };

  const handleSave = () => {
    axios.put(`http://localhost:3000/permisos/${editPermiso.id}`, newPermiso)
      .then(response => {
        setPermisos(permisos.map(p => p.id === editPermiso.id ? response.data : p));
        setFilteredPermisos(filteredPermisos.map(p => p.id === editPermiso.id ? response.data : p));
        setEditPermiso(null);
      })
      .catch(error => {
        console.error('Error updating permiso:', error);
      });
  };

  const handleDelete = (id) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar este permiso?')) {
      axios.delete(`http://localhost:3000/permisos/${id}`)
        .then(() => {
          setPermisos(permisos.filter(p => p.id !== id));
          setFilteredPermisos(filteredPermisos.filter(p => p.id !== id));
        })
        .catch(error => {
          console.error('Error deleting permiso:', error);
        });
    }
  };

  const handleAdd = () => {
    axios.post('http://localhost:3000/permisos', newPermiso)
      .then(response => {
        setPermisos([...permisos, response.data]);
        setFilteredPermisos([...filteredPermisos, response.data]);
        setNewPermiso({ terceroId: '', fecha: '', funeraria: '', horaDefuncion: '', observaciones: '', sepulturaId: '', idLinea: '' });
      })
      .catch(error => {
        console.error('Error adding permiso:', error);
      });
  };

  // Paginación
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredPermisos.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredPermisos.length / recordsPerPage);

  return (
    <div style={{ padding: '20px' }}>
      <h1>Lista de Permisos</h1>
      <input
        type="text"
        placeholder="Buscar por Tercero ID"
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ marginBottom: '20px', padding: '10px', width: '100%' }}
      />
      
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>ID</th><th>Tercero ID</th><th>Fecha</th><th>Funeraria</th>
            <th>Hora Defunción</th><th>Observaciones</th><th>Sepultura ID</th><th>ID Línea</th><th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.map(permiso => (
            <tr key={permiso.id}>
              <td>{permiso.id}</td>
              <td>{permiso.terceroId}</td>
              <td>{permiso.fecha}</td>
              <td>{permiso.funeraria}</td>
              <td>{permiso.horaDefuncion}</td>
              <td>{permiso.observaciones}</td>
              <td>{permiso.sepulturaId}</td>
              <td>{permiso.idLinea}</td>
              <td>
                <button onClick={() => handleEdit(permiso)}>✏️</button>
                <button onClick={() => handleDelete(permiso.id)}>🗑️</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div>
        <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>◀ Anterior</button>
        <span> Página {currentPage} de {totalPages} </span>
        <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>Siguiente ▶</button>
      </div>

      <h2>Añadir Nuevo Permiso</h2>
      {Object.keys(newPermiso).map(key => (
        <input
          key={key}
          type="text"
          placeholder={key}
          value={newPermiso[key]}
          onChange={e => setNewPermiso({ ...newPermiso, [key]: e.target.value })}
          style={{ margin: '5px', padding: '10px' }}
        />
      ))}
      <button onClick={handleAdd} style={{ padding: '10px', backgroundColor: 'green', color: 'white' }}>➕ Grabar</button>
    </div>
  );
};

export default PermisoList;
*/